import { useState, SyntheticEvent } from "react";
import { MemberCardWithDelete } from "./team-member-card";
import { useTeam } from "./team-member-context";

function App() {
  const { teamMembers, addTeamMember } = useTeam();
  const [name, setName] = useState<string>("");
  const onSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();
    addTeamMember({ name });
    setName("");
  }

  return (
    <div>
      <form onSubmit={onSubmit}>
        <input
          type="text"
          value={name}
          data-testid="name"
          className="text-5xl w-full p-1 bg-stone-300"
          placeholder="Add to my team"
          onChange={e => setName(e.target.value)}
        />
        <button type="submit" disabled={!name} className="collapse w-0">Add to my team</button>
      </form>

      <h1 className="text-4xl pt-10">Team members</h1>
      {teamMembers.length === 0 ? <p className="pt-4">Your team is empty</p> : <></>}

      <div className="pt-4 grid grid-flow-row grid-cols-5 auto-rows-max grid-flow-row gap-4">
        {teamMembers.map(member => <MemberCardWithDelete key={member.id} member={member} />)}
      </div>
    </div>
  );
}

export default App;
